// 检测当前应用网络情况
/**
 * wifi
 * 4g
 * 3g
 * 2g
 * offline
 * unknown
 * other
 */

export function getNetInfo() {
  const connection =
    window.navigator.connection ||
    window.navigator.mozConnection ||
    window.navigator.webkitConnection ||
    {}
  // https://caniuse.com/#feat=netinfo
  // https://wicg.github.io/netinfo/
  // https://www.davidbcalhoun.com/2010/using-navigator-connection-android/
  // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType

  let type = 'unknown'

  if (!connection) {
    type = 'unknown'
  }
  if (!navigator.onLine) {
    type = 'offline'
  } else if (connection && connection.type) {
    const netTypesMaps = {
      bluetooth: 'other',
      cellular: connection.effectiveType,
      ethernet: connection.effectiveType,
      none: 'none',
      wifi: 'wifi',
      wimax: 'other',
      other: 'other',
      unknown: 'unknown',
    }
    type = netTypesMaps[connection.type]
  } else if (connection.effectiveType) {
    type = connection.effectiveType
  }
  if (!type) {
    type = 'unknown'
  }
  type = type && type.toLowerCase()
  const networks = [
    'wifi',
    '2g',
    '3g',
    '4g',
    'unknown',
    'other',
    'offline',
    'none',
  ]
  for (let i = 0; i < networks.length; i++) {
    if (type.indexOf(networks[i]) >= 0) {
      return networks[i]
    }
  }
}

// if (connection) {
//   // 当前网络切换时触发
//   connection.addEventListener('change', () => {
//     // window.console.log('=== 当前网络为 ===', getNetInfo())
//   })
// }

// window.addEventListener('online', () => {
//   window.console.log('网络连接恢复！')
// })
// window.addEventListener('offline', () => {
//   window.console.log('网络连接中断！')
// })

export const track_network = () => {
  const network = getNetInfo()
  gtag('event', 'network', {
    event_label: network,
    event_category: 'network',
    non_interaction: true,
  })
}
